import { ComparisonFilterType } from '@/types/compare-offers';
import { atom } from 'jotai';

export interface ComparisonFilterState {
  activeFilter?: ComparisonFilterType;
  filteredItemIds: string[];
}

export const comparisonFilterState = atom<ComparisonFilterState>({
  activeFilter: undefined,
  filteredItemIds: [],
});

// Helper atom for resetting the filter
export const resetComparisonFilterAtom = atom(null, (get, set) => {
  set(comparisonFilterState, {
    activeFilter: undefined,
    filteredItemIds: [],
  });
});
